/** @format */

import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Cookies from "universal-cookie";


const cookie = new Cookies();
const token = cookie.get("token");

export const authApi = createApi({
  reducerPath: "reqres/api",
  tagTypes: ["admin"],
  prepareHeaders: (headers, { getState }) => {
    // const token = getState().authSlice.token;
    if (token) {
      headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
  },
  baseQuery: fetchBaseQuery({
    baseUrl: "https://oncomed.up.railway.app/auth",
    prepareHeaders: (headers, { getState }) => {
      // const token = getState().authSlice.token;
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (build) => ({
    login: build.mutation({
      query: (body) => ({
        url: "/login",
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "admin", id: "LIST" }],
    }),
    addAdmin: build.mutation({
      query: (body) => ({
        url: `/addadmin`,
        method: "POST",
        body,
      }),
      invalidatesTags: [{ type: "admin", id: "LIST" }],
    }),
  }),
});

export const { useLoginMutation, useAddAdminMutation } = authApi;
